import { render, staticRenderFns } from "./safe-area-bottom.vue?vue&type=template&id=38aece90&scoped=true&lang=pug"
import script from "./safe-area-bottom.vue?vue&type=script&lang=js"
export * from "./safe-area-bottom.vue?vue&type=script&lang=js"
import style0 from "./safe-area-bottom.vue?vue&type=style&index=0&id=38aece90&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aece90",
  null
  
)

export default component.exports